"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _uiKit = require("@icis/ui-kit");
var _SessionBanner = require("./SessionBanner.style");
var _SessionModal = _interopRequireDefault(require("./SessionModal"));
var _types = require("./types");
const SessionBanner = _ref => {
  var _bannerContent$closeB, _bannerContent$textBa, _bannerContent$textBa2, _bannerContent$button, _bannerContent$button2, _bannerContent$button3, _bannerContent$button4, _modalContent$modalTi, _modalContent$modalTi2, _modalContent$modalBo, _modalContent$modalBo2, _modalContent$button, _modalContent$button$, _modalContent$button2, _modalContent$button3;
  let {
    ModalComp,
    isMobile,
    banner,
    locale
  } = _ref;
  const {
    bannerContent = _types.defaultBannerContent,
    modalContent = _types.defaultModalContent
  } = banner;
  const [isModalOpen, setModalOpen] = (0, _react.useState)(false);
  const [showBanner, setShowBanner] = (0, _react.useState)(() => {
    const storedValue = localStorage.getItem('showSessionBanner');
    return storedValue !== null ? JSON.parse(storedValue) : true;
  });
  (0, _react.useEffect)(() => {
    const appRoot = document.querySelector('#icis-app-root');
    localStorage.setItem('showSessionBanner', JSON.stringify(showBanner));
    if (appRoot && appRoot instanceof HTMLElement) {
      appRoot.style.height = showBanner ? '104px' : '56px';
    }
  }, [showBanner]);
  const handleOpenModal = () => {
    setModalOpen(true);
  };
  const handleCloseModal = () => {
    setModalOpen(false);
  };
  const handleBannerClose = () => {
    setShowBanner(false);
  };
  if (!showBanner) return null;
  return /*#__PURE__*/_react.default.createElement(_uiKit.Banner, {
    testId: "session-banner",
    hideCloseButton: !(bannerContent !== null && bannerContent !== void 0 && (_bannerContent$closeB = bannerContent.closeButton) !== null && _bannerContent$closeB !== void 0 && _bannerContent$closeB.isDisplayed),
    level: "Info",
    version: "V2",
    hideReloadButton: true,
    textPosition: "center",
    onClose: handleBannerClose
  }, /*#__PURE__*/_react.default.createElement(_SessionBanner.StyledBanner, null, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    icon: _uiKit.IconKeys.warningTriangle
  }), /*#__PURE__*/_react.default.createElement(_SessionBanner.StyledText, {
    isMobile: isMobile
  }, (_bannerContent$textBa = bannerContent === null || bannerContent === void 0 ? void 0 : (_bannerContent$textBa2 = bannerContent.textBanner) === null || _bannerContent$textBa2 === void 0 ? void 0 : _bannerContent$textBa2[locale]) !== null && _bannerContent$textBa !== void 0 ? _bannerContent$textBa : ''), (bannerContent === null || bannerContent === void 0 ? void 0 : (_bannerContent$button = bannerContent.button) === null || _bannerContent$button === void 0 ? void 0 : _bannerContent$button.isDisplayed) && /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    testId: 'session-banner-open-modal',
    variant: 'Tertiary',
    onClick: handleOpenModal
  }, (_bannerContent$button2 = bannerContent === null || bannerContent === void 0 ? void 0 : (_bannerContent$button3 = bannerContent.button) === null || _bannerContent$button3 === void 0 ? void 0 : (_bannerContent$button4 = _bannerContent$button3.text) === null || _bannerContent$button4 === void 0 ? void 0 : _bannerContent$button4[locale]) !== null && _bannerContent$button2 !== void 0 ? _bannerContent$button2 : '')), isModalOpen && /*#__PURE__*/_react.default.createElement(_SessionModal.default, {
    testId: 'session-modal',
    title: (_modalContent$modalTi = modalContent === null || modalContent === void 0 ? void 0 : (_modalContent$modalTi2 = modalContent.modalTitle) === null || _modalContent$modalTi2 === void 0 ? void 0 : _modalContent$modalTi2[locale]) !== null && _modalContent$modalTi !== void 0 ? _modalContent$modalTi : '',
    bodyMessages: (_modalContent$modalBo = modalContent === null || modalContent === void 0 ? void 0 : (_modalContent$modalBo2 = modalContent.modalBody) === null || _modalContent$modalBo2 === void 0 ? void 0 : _modalContent$modalBo2[locale]) !== null && _modalContent$modalBo !== void 0 ? _modalContent$modalBo : [''],
    isDisplayedCloseButton: Boolean(modalContent === null || modalContent === void 0 ? void 0 : (_modalContent$button = modalContent.button) === null || _modalContent$button === void 0 ? void 0 : _modalContent$button.isDisplayed),
    closeButtonText: (_modalContent$button$ = modalContent === null || modalContent === void 0 ? void 0 : (_modalContent$button2 = modalContent.button) === null || _modalContent$button2 === void 0 ? void 0 : (_modalContent$button3 = _modalContent$button2.text) === null || _modalContent$button3 === void 0 ? void 0 : _modalContent$button3[locale]) !== null && _modalContent$button$ !== void 0 ? _modalContent$button$ : '',
    onClose: handleCloseModal,
    ModalComp: ModalComp
  }));
};
var _default = exports.default = SessionBanner;